import Vue from 'vue';
import VueRouter from 'vue-router';
import home from '@/views/home.vue';
import app from '@/views/app.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: home,
    name: 'Home'
  },
  {
    path: '/app',
    component: app,
    name: 'App'
  },

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
